/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { createStyles } from '@/utils/styles';
import { FlexBox, Text, Title } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';
import { useTranslations } from '@/hooks/useTranslations';
import { getItem } from '@/utils/storageUtils';

const Banner = () => {
    const { t } = useTranslations();
    const user = getItem('user');

    return (
        <div className={'banner'} data-testid="banner-container">
            <FlexBox direction="Column" style={styles.flexBox} gap={20}>
                <Title level="H2" size="H2" data-testid="welcome-title" style={styles.title}>
                    👋 {t('WELCOME_TITLE')}, {user?.given_name}!
                </Title>
                <Text data-testid="banner-description" style={styles.text}>
                    {t('BANNER_TEXT')}
                </Text>
            </FlexBox>
        </div>
    );
};

export default Banner;

const styles = createStyles({
    flexBox: {
        paddingLeft: ThemingParameters.sapContent_Margin_Large,
        padding: '3rem',
    },
    title: {
        color: ThemingParameters.sapBaseColor,
        fontSize: 32,
    },
    text: {
        color: ThemingParameters.sapBaseColor,
        fontSize: 18,
        display: 'flex',
        maxWidth: 750,
        fontWeight: 300,
    },
    boldText: {
        fontWeight: 700,
    },
});
